import { Skeleton } from "@/components/ui/skeleton";

export function TipSkeleton() {
  return (
    <div className="bg-vaseline-navy/50 rounded-3xl p-6 backdrop-blur-sm">
      <div className="flex justify-between items-center gap-4">
        <div className="flex-1">
          <Skeleton className="h-4 w-3/4 mb-2 bg-white/10" />
          <Skeleton className="h-4 w-1/2 bg-white/10" />
        </div>
        <div className="flex-shrink-0">
          <Skeleton className="h-12 w-12 rounded-full bg-white/10" />
        </div>
      </div>
    </div>
  );
}